var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timeLeft > 0)?_c('div',{staticClass:"countdown-timer"},[_c('div',[_c('p',[_c('span',{staticClass:"subject mr-1"},[_vm._v("Expired In:")]),_vm._v(" "+_vm._s(_vm.paddedHours)+"h, "+_vm._s(_vm.paddedMinutes)+"m, "+_vm._s(_vm.paddedSeconds)+"s")])])]):_c('div',{staticClass:"countdown-timer"},[_c('p',{staticClass:"title"},[_vm._v("Time's up!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }